<template>
  <div class="product-price-mobile">
    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-content">
        <h1 class="banner-title">产品定价</h1>
        <p class="banner-subtitle">可根据您的企业规模和需求<br>选择不同的产品、版本和部署方式</p>
      </div>

      <!-- 版本板块 - 在banner内部 -->
      <div class="version-section">
        <div class="version-cards">
          <!-- 使用 Swiper 替换自定义轮播 -->
          <div class="swiper version-swiper" ref="versionSwiper">
            <div class="swiper-wrapper">
              <div v-for="(item, idx) in versionList" :key="idx" class="swiper-slide version-slide">
                <div class="version-card" :class="[item.className, { 'current-card': idx === currentSlide }]" :style="{
                  backgroundImage: `url(${item.img})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right 0 top 0',
                  backgroundSize: '100% 100%'
                }">
                  <div class="version-card-desc" :style="{ color: item.descColor }">{{ item.desc }}</div>
                  <div class="version-card-bottom">
                    <div class="version-card-info" :style="{ background: item.infoBg }">
                      <div class="version-card-info-item">
                        <img :src="item.robotIcon" class="version-card-info-icon" alt="机器人" />
                        <span>{{ item.robot }}</span>
                      </div>
                      <div class="version-card-info-item">
                        <img :src="fireIcon" class="version-card-info-icon" alt="对话条数" />
                        <span class="version-card-info-text">{{ item.dialog }}</span>
                      </div>
                    </div>
                    <div class="version-card-price" :style="{
                      background: item.priceColor,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      color: 'transparent',
                    }">{{ item.price }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 表格板块 -->
    <div class="table-section">
      <div class="table-header">
        <h2 class="table-title">版本权益对比</h2>
      </div>

      <div class="table-wrapper">
        <table class="price-table">
          <thead>
            <tr>
              <th class="feature-col">功能与服务</th>
              <th class="plan-col">基础版</th>
              <th class="plan-col">企业版</th>
              <th class="plan-col">旗舰版</th>
              <th class="plan-col">企业改智</th>
              <th class="plan-col">OEM定制</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rIdx) in tableData" :key="rIdx">
              <td class="feature-name">{{ row[0] }}</td>
              <td v-for="(cell, cIdx) in row.slice(1)" :key="cIdx" class="table-cell">
                <template v-if="cell === true">
                  <img :src="tickIcon" alt="支持" class="icon-tick" />
                </template>
                <template v-else-if="cell === false">
                  <img :src="poorIcon" alt="不支持" class="icon-poor" />
                </template>
                <template v-else>
                  <span v-html="cell"></span>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 量身订制板块 -->
    <div class="custom-section">
      <div class="custom-content">
        <div class="custom-header">
          <h2 class="custom-title">支持量身定制智能客服</h2>
          <p class="custom-subtitle">为您的独特业务场景量身打造智能客服中枢<br>突破标准化限制，释放无限服务潜能统</p>
        </div>

        <div class="custom-cards">
          <div class="custom-card" v-for="(item, idx) in customCardList" :key="idx">
            <div class="custom-card-content">
              <h3 class="custom-card-title" v-html="item.title"></h3>
              <p class="custom-card-desc">{{ item.desc }}</p>
            </div>
            <div class="custom-card-img">
              <img :src="item.img" :alt="item.alt" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 统计板块 -->
    <div class="statistics-section">
      <div class="statistics-grid">
        <div class="statistics-item" v-for="item in statisticsList" :key="item.title">
          <div class="statistics-info">
            <div class="statistics-value">{{ item.currentValue }}<span v-if="item.title !== '注册用户数量'">{{ item.title ===
              '问题处理率' || item.title === '客户满意度' || item.title === '释放人力' ? '%' : '' }}</span><span
                v-if="item.title === '注册用户数量'">+</span></div>
            <div class="statistics-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入 Swiper 类
import Swiper from 'swiper'
import 'swiper/swiper-bundle.css'

// 引入PC端的图片资源
import versionImg1 from '../../assets/img/price/pc/version_img1.png'
import versionImg2 from '../../assets/img/price/pc/version_img2.png'
import versionImg3 from '../../assets/img/price/pc/version_img3.png'
import versionImg4 from '../../assets/img/price/pc/version_img4.png'
import versionImg5 from '../../assets/img/price/pc/version_img5.png'
import versionImg6 from '../../assets/img/price/pc/version_img6.png'
import fireIcon from '../../assets/img/price/pc/fire_icon.png'
import robotIcon1 from '../../assets/img/price/pc/robot_icon1.png'
import robotIcon2 from '../../assets/img/price/pc/robot_icon2.png'
import robotIcon3 from '../../assets/img/price/pc/robot_icon3.png'
import robotIcon4 from '../../assets/img/price/pc/robot_icon4.png'
import robotIcon5 from '../../assets/img/price/pc/robot_icon5.png'

import tickIcon from '../../assets/img/price/pc/tick_icon.png'
import poorIcon from '../../assets/img/price/pc/poor_icon.png'

import statisticscon1 from '../../assets/img/product/pc/statistics_icon1.png'
import statisticscon2 from '../../assets/img/product/pc/statistics_icon2.png'
import statisticscon3 from '../../assets/img/product/pc/statistics_icon3.png'
import statisticscon4 from '../../assets/img/product/pc/statistics_icon4.png'

import customImg1 from '../../assets/img/price/pc/custom_img1.png'
import customImg2 from '../../assets/img/price/pc/custom_img2.png'
import customImg3 from '../../assets/img/price/pc/custom_img3.png'

export default {
  name: 'ProductPriceMobile',
  data() {
    return {
      // 版本相关图片
      versionImg1,
      versionImg2,
      versionImg3,
      versionImg4,
      versionImg5,
      versionImg6,
      fireIcon,
      robotIcon1,
      robotIcon2,
      robotIcon3,
      robotIcon4,
      robotIcon5,

      // 版本列表数据
      versionList: [
        {
          img: versionImg2,
          desc: '适合中小企业及初创团队，自动化处理高频客服需求，显著提升响应效率，实现降本增效。',
          descColor: '#2B5183',
          infoBg: '#D0F0FF',
          robotIcon: robotIcon2,
          robot: '机器人工作台50个',
          dialog: '每月赠送对话条数30万条',
          price: '￥6900/年',
          priceColor: 'linear-gradient(35.7deg, #3B84BB 0%, #245C81 100%)',
          className: 'version-card-basic'
        },
        {
          img: versionImg3,
          desc: '适合中大型企业及复杂业务场景，提供深度定制与全渠道智能客服平台，满足个性化需求，提升服务效能与客户满意度。',
          descColor: '#845028',
          infoBg: '#FFE8D9',
          robotIcon: robotIcon3,
          robot: '机器人工作台100个',
          dialog: '每月赠送对话条数80万条',
          price: '￥12900/年',
          priceColor: 'linear-gradient(35.7deg, #AC7159 0%, #683D2A 100%)',
          className: 'version-card-enterprise'
        },
        {
          img: versionImg4,
          desc: '适合集团型公司及大型组织，构建集团级智能客服中枢，实现统一管控、高级分析与安全保障，保障业务连续性与数据合规。',
          descColor: '#7D4E2A',
          infoBg: '#FFECD0',
          robotIcon: robotIcon4,
          robot: '机器人工作台无限个',
          dialog: '每月赠送对话条数120万条',
          price: '￥26900/年',
          priceColor: 'linear-gradient(35.7deg, #CF9356 0%, #834E1C 100%)',
          className: 'version-card-flagship'
        },
        {
          img: versionImg5,
          desc: '专为超大型组织及复杂业务体量设计，内置顶级安全架构与专属支持团队，确保高并发稳定运行与核心业务零风险。',
          descColor: '#2E3195',
          infoBg: '#D6D0FF',
          robotIcon: robotIcon5,
          robot: '机器人工作台无限个',
          dialog: '每月赠送对话条数500万条',
          price: '￥99900/年',
          priceColor: 'linear-gradient(35.7deg, #7375D0 0%, #2B0E6F 100%)',
          className: 'version-card-vip'
        },
        {
          img: versionImg6,
          desc: '适合企业及团队，定制化AI客服服务，可对接小程序/官网/APP等不同场景的接入。',
          descColor: '#2B5183',
          infoBg: '#ccc8e9',
          robotIcon: robotIcon2,
          robot: '机器人工作台50-1000个',
          dialog: '每月对话条数100万条起',
          price: '￥咨询我们',
          priceColor: 'linear-gradient(35.7deg, #3B84BB 0%, #245C81 100%)',
          className: 'version-card-basic'
        }
      ],

      // 表格相关
      tickIcon,
      poorIcon,
      tableData: [
        ['工作台数量', '50个', '100个', '无限个', '无限个', '无限个'],
        ['额外增购优惠', false, '800元<br>个/年', '800元<br>个/年', '600元<br>个/年', '600元<br>个/年'],
        ['赠送对话条数', '30万条', '80万条', '120万条', '500万条', '面议'],
        ['专业技术支持', true, true, true, true, true],
        ['智能回复', true, true, true, true, true],
        ['产品训练', true, true, true, true, true],
        ['数据统计分析', true, true, true, true, true],
        ['智能质检', true, true, true, true, true],
        ['人机协同', true, true, true, true, true],
        ['自主学习', true, true, true, true, true],
        ['话术优化建议', false, true, true, true, true],
        ['跨店铺知识库共享', false, false, false, true, true],
        ['AI训练中心', false, false, false, true, true],
        ['实时监控大屏', false, false, false, true, true],
      ],

      // 统计数据
      statisticscon1,
      statisticscon2,
      statisticscon3,
      statisticscon4,
      statisticsList: [
        { title: '注册用户数量', value: 3000, currentValue: 0 },
        { title: '释放人力', value: 60, currentValue: 0 },
        { title: '问题处理率', value: 95, currentValue: 0 },
        { title: '客户满意度', value: 98.5, currentValue: 0 }
      ],

      // 量身订制卡片数据
      customCardList: [
        {
          title: '私有化部署<br>企业级数据主权与安全闭环',
          desc: '智能客服本地化部署，实现核心数据物理隔离与全生命周期管控，满足金融、政务等高敏行业严苛合规要求',
          img: customImg1,
          alt: '私有化部署'
        },
        {
          title: '专属算法优化<br>垂直场景驱动的AI模型调优',
          desc: '基于行业知识库与业务规则强化训练NLP引擎，优化容错机制，显著提升意图识别精度（95%→99.5%）并降低转人工率。 ',
          img: customImg2,
          alt: '专属算法优化'
        },
        {
          title: 'ERP系统对接<br>业服一体化深度集成方案',
          desc: '通过API网关与中间件实现智能客服与主流ERP实时双向贯通，自动同步订单等数据，赋能客服全链路闭环管理。',
          img: customImg3,
          alt: 'ERP系统对接'
        }
      ],

      // Swiper 相关数据
      currentSlide: 0,
      swiperInstance: null
    }
  },
  methods: {
    // 初始化 Swiper
    initSwiper() {
      this.$nextTick(() => {
        if (this.$refs.versionSwiper) {
          this.swiperInstance = new Swiper(this.$refs.versionSwiper, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 0,
            loop: true,
            grabCursor: true,
            on: {
              slideChange: (swiper) => {
                this.currentSlide = swiper.realIndex
              }
            }
          })
        }
      })
    },
    // 数字动画
    animateNumber(idx, target, duration = 1000) {
      const start = 0;
      const isPercent = target <= 100;
      const end = target;
      const startTime = performance.now();
      const step = (now) => {
        const elapsed = now - startTime;
        let progress = Math.min(elapsed / duration, 1);
        let value = start + (end - start) * progress;
        if (isPercent) {
          value = Math.round(value * 10) / 10;
        } else {
          value = Math.floor(value);
        }
        this.$set(this.statisticsList, idx, {
          ...this.statisticsList[idx],
          currentValue: value
        });
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          this.$set(this.statisticsList, idx, {
            ...this.statisticsList[idx],
            currentValue: end
          });
        }
      };
      requestAnimationFrame(step);
    }
  },
  mounted() {
    // 初始化 Swiper
    this.initSwiper()

    // 启动统计数字动画
    setTimeout(() => {
      this.statisticsList.forEach((item, idx) => {
        this.animateNumber(idx, item.value, 1200);
      });
    }, 500);
  },
  beforeDestroy() {
    // 销毁 Swiper 实例
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true)
      this.swiperInstance = null
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/mobile-responsive.scss' as mobile;

.product-price-mobile {
  @include mobile.mobile-page-content;
  background-color: #F5F7FB;
  width: 100%;
  overflow-x: hidden; // 防止水平滚动

  // Banner区域
  .banner {
    position: relative;
    height: mobile.px2rem(491);
    background: url('../../assets/img/price/mobile/banner.png') no-repeat center center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    overflow-x: hidden;
    overflow-y: visible;

    .banner-content {

      .banner-title {
        font-size: mobile.px2rem(20);
        font-weight: 800;
        color: #fff;
        margin-top: mobile.px2rem(25);
        margin-bottom: mobile.px2rem(8);
      }

      .banner-subtitle {
        font-size: mobile.px2rem(14);
        font-weight: 500;
        color: #FFFFFF;
      }
    }

    // 版本板块
    .version-section {
      position: absolute;
      bottom: mobile.px2rem(14);
      left: 0;
      right: 0;
      padding: 0;

      .version-cards {
        position: relative;
        overflow: visible;
        width: 100%;

        .version-swiper {
          overflow: visible;

          .swiper-slide {
            width: mobile.px2rem(244);
            display: flex;
            justify-content: center;
            align-items: flex-end;
          }

          .version-card {
            position: relative;
            width: mobile.px2rem(244);
            height: mobile.px2rem(342);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            overflow: hidden;
            cursor: grab;
            transition: transform 0.3s ease, opacity 0.3s ease;
            transform: scale(0.868);
            opacity: 0.9;
            z-index: 1;
            transform-origin: center bottom;

            &:active {
              cursor: grabbing;
            }

            // 当前卡片稍微大一点
            &.current-card {
              transform: scale(1.0);
              opacity: 1;
              z-index: 2;
              transform-origin: center bottom;
            }

            .version-card-desc {
              font-weight: 500;
              font-size: mobile.px2rem(14);
              line-height: mobile.px2rem(22);
              word-break: break-all;
              margin-top: mobile.px2rem(110);
              flex: 1 1 auto;
              padding: 0 mobile.px2rem(14);
              text-align: left;
            }

            .version-card-bottom {
              width: 100%;
              padding: 0 mobile.px2rem(9);

              .version-card-info {
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: mobile.px2rem(8);
                border-radius: mobile.px2rem(8);
                padding: mobile.px2rem(6) 0 mobile.px2rem(6) mobile.px2rem(24);
                box-sizing: border-box;

                .version-card-info-item {
                  display: flex;
                  align-items: center;
                  font-weight: 400;
                  font-size: mobile.px2rem(13);
                  gap: mobile.px2rem(9);


                  .version-card-info-icon {
                    width: mobile.px2rem(22);
                    height: mobile.px2rem(22);
                    object-fit: contain;
                  }
                }
              }

              .version-card-price {
                width: 100%;
                text-align: center;
                font-weight: 800;
                font-size: mobile.px2rem(28);
                line-height: mobile.px2rem(28);
                margin: mobile.px2rem(12) 0;
              }
            }
          }
        }
      }
    }
  }

  // 表格板块
  .table-section {
    padding: mobile.px2rem(27) mobile.px2rem(0) mobile.px2rem(0);
    // background: #fff;
    margin-bottom: mobile.px2rem(28);

    .table-header {
      text-align: center;
      margin-bottom: mobile.px2rem(16);

      .table-title {
        font-size: mobile.px2rem(20);
        font-weight: 800;
        color: #333;
      }
    }

    .table-wrapper {
      overflow-x: visible;
      background: #fff;
      border-radius: 20px;
      padding: mobile.px2rem(20) mobile.px2rem(17) mobile.px2rem(10);

      .price-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          tr {
            border-bottom: mobile.px2rem(8) solid transparent;
          }

          th {
            text-align: center;
            font-weight: 500;

            &.feature-col {
              // width: 25%;
              color: #333;
              font-size: mobile.px2rem(14);
            }

            &.plan-col {
              width: mobile.px2rem(50);
              height: mobile.px2rem(36);
              color: #666666;
              font-size: mobile.px2rem(12);
            }
          }
        }

        tbody {
          tr {
            border-bottom: mobile.px2rem(8) solid transparent;

            &:last-child {
              border-bottom: none;
            }
          }

          td {
            text-align: center;
            font-weight: 500;
            vertical-align: middle;

            &.feature-name {
              color: #333;
              font-size: mobile.px2rem(14);
            }

            &.table-cell {
              width: mobile.px2rem(50);
              height: mobile.px2rem(36);
              color: #666666;
              font-size: mobile.px2rem(12);
            }

            .icon-tick,
            .icon-poor {
              width: mobile.px2rem(16);
              height: mobile.px2rem(16);
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }

  // 量身订制板块
  .custom-section {
    background-size: cover;
    padding: 0 mobile.px2rem(20);
    margin-bottom: mobile.px2rem(16);

    .custom-content {
      .custom-header {
        text-align: center;
        margin-bottom: mobile.px2rem(24);

        .custom-title {
          font-size: mobile.px2rem(20);
          line-height: mobile.px2rem(20);
          font-weight: 800;
          color: #333333;
          margin-bottom: mobile.px2rem(10);
        }

        .custom-subtitle {
          font-weight: 500;
          font-size: mobile.px2rem(14);
          color: #333;
          margin: 0;
        }
      }

      .custom-cards {
        display: flex;
        flex-direction: column;
        gap: mobile.px2rem(16);

        .custom-card {
          background: linear-gradient(180deg, #E2F0FF 20%, #fcfdfe 100%);
          border-radius: mobile.px2rem(4);
          border: 2px solid #FFFFFF;
          padding-left: mobile.px2rem(16);
          display: flex;
          align-items: flex-start;

          .custom-card-content {
            flex: 1;
            text-align: left;
            padding: mobile.px2rem(12) 0;

            .custom-card-title {
              font-size: mobile.px2rem(14);
              font-weight: 800;
              color: #3B5699;
              margin-bottom: mobile.px2rem(4);
            }

            .custom-card-desc {
              font-size: mobile.px2rem(12);
              font-weight: 500;
              color: #6A7FB7;
              margin: 0;
            }
          }

          .custom-card-img {
            width: mobile.px2rem(120);
            height: mobile.px2rem(120);
            flex-shrink: 0;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }
  }

  // 统计板块
  .statistics-section {
    padding: mobile.px2rem(18) mobile.px2rem(15);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.5) 100%);
    box-shadow: 0px 2px 8px 0px rgba(38, 71, 124, 0.15);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #FFFFFF;
    margin-bottom: mobile.px2rem(16);

    .statistics-grid {
      // display: grid;
      // grid-template-columns: repeat(4, 1fr);
      display: flex;
      justify-content: space-between;

      .statistics-item {
        display: flex;
        align-items: center;
        justify-content: center;

        .statistics-info {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;

          .statistics-value {
            font-size: mobile.px2rem(20);
            font-weight: 800;
            color: #333333;
            line-height: 1;
            margin-bottom: mobile.px2rem(4);
          }

          .statistics-title {
            font-size: mobile.px2rem(14);
            color: #666;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>